<template>
    <div style="width:100%; box-sizing: border-box; text-align: left;">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>


    <div style="width:100%; box-sizing:border-box; max-width:500px; margin:0px auto; display:block;">

        <GrcText ref="txtFelhasznalonev"
        grc_labeltext="Felhasználónév:"
        grc_placeholder="..."
        grc_labelmode="" grc_labelwidth="200px" 
        v-on:grc-keydown-enter="SetControlToFocus('txtEmailCim');"
        style="margin-bottom:20px;"
        />

        <GrcText ref="txtEmailCim"
        grc_labeltext="E-mail cím:"
        grc_placeholder="..."
        grc_labelmode="" grc_labelwidth="200px" 
        style="margin-bottom:20px;"
        />

        <div style="width:100%; box-sizing:border-box; text-align:center;">

            <span @click="btnOK_click" class="painted_linkbutton2 color3" style="margin: 4px 8px;">
                <span><i class="fal fa-check" style="margin-right: 4px;"></i>Küldés</span>
            </span>                                        

            <span @click="btnMegsem_click" class="painted_linkbutton2 color7" style="margin: 4px 8px;">
                <span><i class="fal fa-times" style="margin-right: 4px;"></i>Mégsem</span>
            </span>                                        

        </div>   


    </div>


    </div>
</template>

<script>

import GrcText from '../GrcComponents/GrcText.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'


export default {
  name: 'frmelfelejtettjelszo',
  components: {
      GrcDB,
      GrcDialog,
      GrcText,
  },
  props: {

  },
  data () {
      return {
          WSPREFIX: "frmElfelejtettJelszo_",

      }
  },
  model: {
  },  
  methods:{
    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmElfelejtettJelszo", pCompName);
    },

    SetLang()
    {
        this.$refs.txtEmailCim.HideError();
        this.$refs.txtFelhasznalonev.HideError();
    },

    btnOK_click(e)
    {
      this.SendPWD();
    },

    HideErrors()
    {
      this.$refs.txtEmailCim.HideError();
      this.$refs.txtFelhasznalonev.HideError();
    },

    btnMegsem_click(e)
    {
      document.location = "bejelentkezes";
    },



      async SendPWD()
      {
        this.HideErrors();

        var ErrorCompName = "";
        if (grcmain_IsValidEmailAddress(this.$refs.txtEmailCim.GetText()) == false)
        {
          if (ErrorCompName == "") { ErrorCompName = "txtEmailCim"; }
          if (this.$refs.txtEmailCim.GetText() == "")
          {
            this.$refs.txtEmailCim.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
          }
          else
          {
            this.$refs.txtEmailCim.ShowError(grcmain_GetTextBookItem("tech", "email_format_error"));
          }
        }


          
        if (this.$refs.txtFelhasznalonev.GetText() == "")
        {
          if (ErrorCompName == "") { ErrorCompName = "txtFelhasznalonev"; }
          this.$refs.txtFelhasznalonev.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }


        if (ErrorCompName != "")
        {
          this.SetControlToFocus(ErrorCompName);
          return;
        }


        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sEmailCim: this.$refs.txtEmailCim.GetText(),
            sFelhasznalonev: this.$refs.txtFelhasznalonev.GetText(),
            sIPAddress: "[IPADDRESS]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "SendPwd", QP).then(res => { Q = res; });

        
        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowInfo(Q.APPERR[0].ERR, 200);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        if (Q.SENDPWDRESULT[0].intResult == 1)
        {

            var DialogResult = "";
            var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), Q.SENDPWDRESULT[0].strResult);             
            p.height = 200;
            p.width = 400;
            p.padding_top = -1;
            if (grccomp_getScreenSize().width < 400) { p.width = 300; }
            await this.$refs.Dialog.ShowDialog(p).then(res => { DialogResult = res; });    
            
            document.location = "bejelentkezes";

            return;
        }



        if (Q.SENDPWDRESULT[0].strResult != "")
        {
          await this.ShowInfo(Q.SENDPWDRESULT[0].strResult, 200);
        }
      },



      SetControlToFocus(pNextComp)
      {
        if (pNextComp == "") { return; }
        this.$refs[pNextComp].SetFocus();
      },

    async ShowInfo(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },
  created()
  {

  },
  mounted()
  {
    this.SetLang();

  }

}


</script>


<style scoped>



</style>